import { IRecommend } from './types';

const formatRecommends = (recommends: IRecommend[]) =>
  recommends.map(({ departureCity, arrivalCity, duration, fare, stops }) => ({
    departure: {
      ...departureCity,
      cityCode: departureCity.iataCode,
      rank: departureCity.popularity,
    },
    destination: {
      ...arrivalCity,
      cityCode: arrivalCity.iataCode,
      rank: arrivalCity.popularity,
    },
    totalFare: fare,
    duration,
    stops,
  }));

export { formatRecommends };
